import { Grid, Typography } from '@mui/material';
import * as React from 'react';
import AstronautNotFound from '../Icon/AnstronautNotFound';
import { alpha } from '@mui/system';
import { primary } from 'lib/mui/colors';

export type NoRecordsFoundProps = {
    text?: string;
};

const NoRecordsFound = ({ text = 'No records found' }: NoRecordsFoundProps) => (
    <Grid container justifyContent="center" spacing={3} mt={5}>
        <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }}>
            <AstronautNotFound color={alpha(primary[700], 0.5)} />
        </Grid>
        <Grid item xs={12} style={{ textAlign: 'center' }}>
            <Typography variant="h3" component="p" sx={{ color: alpha(primary[700], 0.5) }}>
                {text}
            </Typography>
        </Grid>
    </Grid>
);

export default NoRecordsFound;
